<template>
  <div class="app-container">
    <div class="params-setting-content">
      <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
        <wt-form-table-list ref="warningParamsTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
          <template slot="count" slot-scope="scope">
            <span v-if="currentIndex !== scope.index">{{ scope.row.count }}</span>
            <el-input v-if="currentIndex === scope.index" size="small" v-model="currentValue"></el-input>
          </template>
          <template slot="wtFormTableListButtonsAfter" slot-scope="scope">
            <wt-auth class="search-form-btn">
              <el-button v-if="currentIndex !== scope.index" :hasAnyPremission="form.formCode + ':EDIT'" size="mini" :type="'primary'" @click="toClickAction(scope, 'EDIT')">编辑</el-button>
              <el-button v-if="currentIndex === scope.index" size="mini" :type="'primary'" @click="toClickAction(scope, 'SAVE')">保存</el-button>
              <el-button v-if="currentIndex === scope.index" size="mini" :type="'primary'" @click="toClickAction(scope, 'CANCEL')">取消</el-button>
            </wt-auth>
          </template>
        </wt-form-table-list>
      </wt-form-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WarningParamsSetting',
  data() {
    return {
      form: { //  表单数据
        hidePage: true,
        isFormLoading: false,
        formCode: 'MODULE_WARNINGPARAMSSETTING',
        formComponent: {
          list: { type: 'default', value: '/modules/warnType/warnTypeList' }
        },
        formInputsData: [],
        formButtonsData: [],
        formTableData: [
          { name: '参数', key: 'garbageName', type: 'text' },
          { name: '参数值', key: 'count', type: 'custom' },
          { name: '操作人', key: 'employeesName', type: 'text' },
          { name: '操作时间', key: 'updateTime', type: 'text', sortable: true }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonWidth: 130 }
      },
      currentIndex: -1,
      currentValue: '',
      currentRow: {}
    }
  },
  methods: {
    onButtonAction() {},
    toClickAction({ row, index }, type) {
      if (type === 'EDIT') {
        this.currentValue = row.count
        this.currentRow = row
        this.currentIndex = index
      }
      if (type === 'SAVE') {
        if (!this.$wtUtil.isGreaterZeroFloat(this.currentValue)) {
          this.$message.warning('仅能输入数字')
          return
        }
        row.value = this.currentValue
        this.currentIndex = -1
        this.toSave()
      }
      if (type === 'CANCEL') {
        this.currentIndex = -1
      }
    },
    toSave() {
      const that = this
      const params = JSON.parse(JSON.stringify(this.currentRow))
      params.count = this.currentValue
      this.$api.warning.params.warnTypeUpdate(params).then(res => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$refs.warningParamsTableRef.requestList()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.params-setting-content {
  padding: 20px 0;
  background-color: #FFFFFF;
}
</style>
